import { defineStore } from 'pinia';
import type {
  SubscriptionModel,
} from '~/common/constants/SubscriptionPlans.ts';

import {
  BASELINE_SUBSCRIPTIONS,
  BASELINE_SUBSCRIPTIONS_EUR,
  COURSE_PLANS,
  COURSE_PLANS_EUR,
} from '~/common/constants/SubscriptionPlans.ts';

export const usePaymentConfigs = defineStore('paymentConfigs', () => {
  type LangKeys = 'en' | 'pt' | 'es-mx' | 'pt-br' | 'es' | 'de';

  const currentConfig = computed(() => {
    const { locale } = useI18n();
    switch (locale.value as LangKeys) {
      case 'en':
      case 'pt':
      case 'es-mx':
      case 'pt-br':
      case 'es':
      case 'de':
      default:
        return BASELINE_SUBSCRIPTIONS as SubscriptionModel[];
    }
  });

  const coursesConfig = computed(() => {
    const { locale } = useI18n();
    switch (locale.value as LangKeys) {
      case 'en':
      case 'pt':
      case 'es-mx':
      case 'pt-br':
      case 'es':
      case 'de':
      default:
        return COURSE_PLANS as SubscriptionModel[];
    }
  });

  return {
    currentConfig,
    coursesConfig,
  };
});
